module.exports = __webpack_public_path__ + "static/media/5_l_bord_50.94_11.76.b2eec2a4.png";